import React, {useEffect, useState} from 'react';
import isEqual from 'lodash/isEqual';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import {Button, Modal} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import moment from 'moment';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Form, Formik} from 'formik';
import ReceiptData from './ReceiptData';
import UnitGrid from './UnitGrid';
import UnitSummaryDetails from './UnitSummaryDetails';
import PopupInvoicesList from './PopupInvoicesList';
import DataItemCheckbox from '../../../../_common/components/DataItemCheckbox';
import can from '../../../../_common/components/Permissions/can';
import * as actions from '../_redux/popupAddReceiptActions';
import {resetDisabledFields} from '../_redux/popupAddReceiptActions';
import * as invoicesListActions from './PopupInvoicesList/redux/popupInvoicesListActions';
import {checkEmailIsValid} from '../../../../_common/utils/checkEmailIsValid';

const PopupAddReceipt = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showPopupInvoicesList, setShowPopupInvoicesList] = useState(false);
  const [disabledFields, setDisabledFields] = useState([]);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const [popupRowIndex, setPopupRowIndex] = useState(0);

  const {currentState} = useSelector((state) => (
      {currentState: state['popupAddReceipt']}),
    shallowEqual
  );

  useEffect(() => {
    const reduxFields = currentState.disabledFields || [];

    if (!isEqual(reduxFields, disabledFields)) {
      setDisabledFields(reduxFields);
    }
  }, [currentState.disabledFields]);

  useEffect(() => {
    if (!isEqual(currentState.disabledFields, disabledFields)) {
      dispatch(actions.saveDisabledFields(disabledFields));
    }
  }, [disabledFields]);

  const intl = useIntl();
  const existingReceiptLabel = intl.formatMessage({
    id: 'receipts-popup-existing-label',
    defaultMessage: 'Existing',
  });
  const newReceiptLabel = intl.formatMessage({
    id: 'receipts-popup-new-label',
    defaultMessage: 'New',
  });
  const existingReceiptHeader = intl.formatMessage({
    id: 'receipts-popup-header-existing',
    defaultMessage: 'Existing receipt',
  });
  const newReceiptHeader = intl.formatMessage({
    id: 'receipts-popup-header-new',
    defaultMessage: 'New receipt',
  });
  const multipleAgentsLabel = intl.formatMessage({
    id: 'receipts-popup-multiple-agents',
    defaultMessage: 'Multiple agents',
  });
  const vatIncludedLabel = intl.formatMessage({
    id: 'receipts-popup-vat-included',
    defaultMessage: 'VAT included',
  });
  const cancelButtonLabel = intl.formatMessage({
    id: 'label-button-cancel',
    defaultMessage: 'Cancel',
  });
  const sendButtonLabel = intl.formatMessage({
    id: 'label-button-send',
    defaultMessage: 'Send',
  });
  const searchInvoices = intl.formatMessage({
    id: 'receipts-popup-button-search-invoices',
    defaultMessage: 'Search invoices',
  });

  const initialValues = {
    customer: '',
    customerID: null,
    receiptType: 'existing',
    multipleAgents: false,
    comment: '',
    customerName: '',
    customerIdNumber: '',
    customerPhone: '',
    customerEmail: '',
    customerCity: '',
    customerAddress: '',
    agentID: '',
    currencyID: {value: 1, label: 'ש"ח'},
    exchangeRate: 1,
    priceIncludeVat: false,
    dueDate: new Date(),
    lines: [],
    invoices: [],
  };
  const valuesSet = {
    accountNumber: '',
    agentID: '',
    amount: '',
    bankCode: '',
    branchNumber: '',
    checkNumber: '',
    description: '',
    dueDate: Date.parse(moment().format('YYYY-MM-DD')),
    paymentType: '',
    invoices: [],
  };

  const receiptTypeArray = [
    {
      id: 'existing',
      receiptType: 'existing',
      label: existingReceiptLabel
    },
    {
      id: 'new',
      receiptType: 'new',
      label: newReceiptLabel
    },
  ];

  const switchReceiptType = (setFieldValue, item) => {
    setFieldValue('receiptType', `${item.receiptType}`);
  };
  const findCustomerAction = (inputValue) => {
    return dispatch(actions.findCustomerAgent(inputValue, false));
  };
  const findAgentAction = (inputValue) => {
    return dispatch(actions.findCustomerAgent(inputValue, true));
  };
  const getInvoicesByCustomer = (customerID) => {
    dispatch(invoicesListActions.getInvoicesByCustomer(customerID));
    setShowPopupInvoicesList(true);
  };

  const createInvoiceReceiptExistingAgent = (data) => {
    return dispatch(actions.createInvoiceReceiptExistingAgent(data));
  };
  const createInvoiceReceiptNewAgent = (data) => {
    return dispatch(actions.createInvoiceReceiptNewAgent(data));
  };

  const preparedDataExistingSingleAgent = (values) => {
    const {
      multipleAgents,
      customer,
      customerEmail,
      agentID,
      currencyID,
      exchangeRate,
      comment,
      lines,
      invoices
    } = values;

    const linesData = (lines && Array.isArray(lines)) && lines.map((item, index) => {

      return {
        description: lines[index].description || '',
        paymentType: lines[index].paymentType ? parseInt(lines[index].paymentType.value) : null,
        dueDate: lines[index].dueDate
          ? Date.parse(moment(lines[index].dueDate).format('YYYY-MM-DD'))
          : Date.parse(moment().format('YYYY-MM-DD')),
        checkNumber: lines[index].checkNumber ? parseInt(lines[index].checkNumber) : null,
        bankCode: lines[index].bankCode ? parseInt(lines[index].bankCode) : null,
        branchNumber: lines[index].branchNumber ? parseInt(lines[index].branchNumber) : null,
        accountNumber: lines[index].accountNumber || '',
        amount: lines[index].amount ? parseFloat(lines[index].amount) : null,
      };
    });

    const invoicesData = (invoices && Array.isArray(invoices)) && invoices.map((item, index) => {

      return {
        invoiceID: invoices[index].invoiceID || '',
        closeAmount: invoices[index].closeAmount ? parseFloat(invoices[index].closeAmount).toFixed(2) : null,
      };
    });

    return {
      multipleAgents: multipleAgents ? 1 : 0,
      customerID: customer ? parseInt(customer._id, 10) : null,
      customerEmail: customerEmail || '',
      agentID: (Boolean(multipleAgents) || Boolean(!agentID)) ? '-1' : parseInt(agentID._id, 10),
      currencyID: currencyID.value ? parseInt(currencyID.value, 10) : null,
      exchangeRate: parseInt(exchangeRate, 10) || null,
      comment: comment || '',
      lines: linesData || [],
      invoices: invoicesData || [],
    };
  };
  const preparedDataExistingMultipleAgents = (values) => {
    const {
      multipleAgents,
      customer,
      customerEmail,
      agentID,
      currencyID,
      exchangeRate,
      comment,
      lines
    } = values;

    const linesData = (lines && Array.isArray(lines)) && lines.map((item, index) => {

      return {
        agentID: Boolean(multipleAgents) ? parseInt(lines[index].agentID._id, 10) : -1,
        description: lines[index].description || '',
        paymentType: lines[index].paymentType ? parseInt(lines[index].paymentType.value) : null,
        dueDate: lines[index].dueDate
          ? Date.parse(moment(lines[index].dueDate).format('YYYY-MM-DD'))
          : Date.parse(moment().format('YYYY-MM-DD')),
        checkNumber: lines[index].checkNumber ? parseInt(lines[index].checkNumber) : null,
        bankCode: lines[index].bankCode ? parseInt(lines[index].bankCode) : null,
        branchNumber: lines[index].branchNumber ? parseInt(lines[index].branchNumber) : null,
        accountNumber: lines[index].accountNumber || '',
        amount: lines[index].amount ? parseFloat(lines[index].amount) : null,
        invoices: lines[index].invoices || [],
      };
    });

    return {
      multipleAgents: multipleAgents ? 1 : 0,
      customerID: customer ? parseInt(customer._id, 10) : null,
      customerEmail: customerEmail || '',
      agentID: (Boolean(multipleAgents) || Boolean(!agentID)) ? '-1' : parseInt(agentID._id, 10),
      currencyID: currencyID.value ? parseInt(currencyID.value, 10) : null,
      exchangeRate: parseInt(exchangeRate, 10) || null,
      comment: comment || '',
      lines: linesData || [],
    };
  };
  const preparedDataNewAgent = (values) => {
    const {
      customerName,
      customerIdNumber,
      customerPhone,
      customerEmail,
      customerCity,
      customerAddress,
      agentID,
      currencyID,
      exchangeRate,
      priceIncludeVat,
      dueDate,
      lines,
    } = values;

    const linesData = (lines && Array.isArray(lines)) && lines.map((item, index) => {

      return {
        description: lines[index].description || '',
        paymentType: lines[index].paymentType ? parseInt(lines[index].paymentType.value) : null,
        checkNumber: `${lines[index].checkNumber}` || '',
        bankCode: lines[index].bankCode ? parseInt(lines[index].bankCode) : null,
        branchNumber: lines[index].branchNumber ? parseInt(lines[index].branchNumber) : null,
        accountNumber: lines[index].accountNumber || '',
        amount: lines[index].amount ? parseFloat(lines[index].amount) : null,
      };
    });

    return {
      customerName: customerName || '',
      customerIdNumber: parseInt(customerIdNumber, 10) || null,
      customerPhone: `${customerPhone}` || '',
      customerEmail: customerEmail || '',
      customerCity: customerCity || '',
      customerAddress: customerAddress || '',
      agentID: agentID ? parseInt(agentID._id, 10) : '-1',
      currencyID: currencyID.value ? parseInt(currencyID.value, 10) : null,
      exchangeRate: parseInt(exchangeRate, 10) || null,
      priceIncludeVat: Boolean(priceIncludeVat),
      dueDate: Date.parse(moment(dueDate).format('YYYY-MM-DD')) || Date.parse(moment().format('YYYY-MM-DD')),
      lines: linesData || [],
    };
  };

  const validate = (values) => {
    let errors = {};
    const {
      multipleAgents,
      receiptType,
      customer,
      agentID,
      currencyID,
      exchangeRate,
      lines,
      customerName,
      customerIdNumber,
      customerEmail,
    } = values;

    if (!checkEmailIsValid(customerEmail) && receiptType === 'new') {
      errors.customerEmailInvalid = 'Invalid email address';
    }

    if (receiptType === 'existing') {
      const arr = Object.keys({customer, currencyID, exchangeRate});
      arr.forEach(function (item) {
        if (!values[item]) errors[item] = 'Required';
      });
    }

    if (receiptType === 'existing' && !Boolean(multipleAgents)) {
      const arr = Object.keys({agentID});
      arr.forEach(function (item) {
        if (!values[item]) errors[item] = 'Required';
      });
    }

    if (receiptType === 'new') {
      const arr = Object.keys({
        customerName,
        customerIdNumber,
        customerEmail,
        agentID,
        currencyID,
        exchangeRate
      });
      arr.forEach(function (item) {
        if (!values[item]) errors[item] = 'Required';
      });
    }

    if (lines.length < 1) {
      errors.lines = 'Required at least one line';
    }

    if (lines.length > 0) {
      const linesData = (lines && Array.isArray(lines)) && lines.map((item, index) => {

        return {
          agentID: lines[index].agentID,
          accountNumber: lines[index].accountNumber,
          amount: lines[index].amount,
          bankCode: lines[index].bankCode,
          branchNumber: lines[index].branchNumber,
          checkNumber: lines[index].checkNumber,
          paymentType: lines[index].paymentType,
        };
      });

      linesData.forEach(function (item) {
        const {
          agentID,
          accountNumber,
          amount,
          bankCode,
          branchNumber,
          checkNumber,
          paymentType
        } = item;
        if (!agentID && Boolean(multipleAgents)) errors['agentID'] = 'Required line item';
        if (!accountNumber && (paymentType.value === 1)) errors['accountNumber'] = 'Required line item';
        if (!amount) errors['amount'] = 'Required line item';
        if (!bankCode && (paymentType.value === 1)) errors['bankCode'] = 'Required line item';
        if (!branchNumber && (paymentType.value === 1)) errors['branchNumber'] = 'Required line item';
        if (!checkNumber && (paymentType.value === 1)) errors['checkNumber'] = 'Required line item';
        if (!paymentType) errors['paymentType'] = 'Required line item';
      });
    }

    return errors;
  };

  const handleFormSubmit = (values, {resetForm}) => {
    submitForm({values, resetForm});
  };

  const submitForm = ({values, resetForm}) => {
    handleCloseModal();
    if (values.receiptType === 'existing' && values.multipleAgents === false) {
      createInvoiceReceiptExistingAgent(preparedDataExistingSingleAgent(values));
    }
    if (values.receiptType === 'existing' && values.multipleAgents === true) {
      createInvoiceReceiptExistingAgent(preparedDataExistingMultipleAgents(values));
    }
    if (values.receiptType === 'new') {
      createInvoiceReceiptNewAgent(preparedDataNewAgent(values));
    }
    setDisabledFields([]);
    dispatch(actions.resetDisabledFields());
    resetForm();
  };

  return (
    <>
      <Button
        type="button"
        className="btn d-flex align-items-center justify-content-center custom-subheader-button h-40px w-40px mx-2"
        disabled={!(can('full', 'receipts'))}
        onClick={handleShowModal}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Receipt_white.svg')}
          alt="receipt"
          height={24}
        />
      </Button>

      <Formik
        initialValues={initialValues}
        onSubmit={() => {
          /* onSubmit doesn't work when form is valid, it's strange but for now just avoid this bug */
        }}
        validate={validate}
        validateOnMount={true}
      >
        {({values, setFieldValue, resetForm, isValid, dirty}) => (
          <Form>
            <Modal
              show={show}
              onShow={() => setDisabledFields([])}
              onHide={handleCloseModal}
              className="popupAddReceiptContainer"
            >
              <Modal.Body>
                <div className="w-50 mx-auto">
                  <div className="ml-40 mr-16 mb-4">
                    <div className="d-flex justify-content-around">
                      {receiptTypeArray.map((item) => {
                        return (
                          <div>
                            <input
                              type="radio"
                              className="hide-checkbox"
                              id={item.id}
                              name="receiptType"
                              checked={values.receiptType === item.receiptType}
                              onChange={() => {
                                switchReceiptType(setFieldValue, item);
                              }}
                            />
                            <label htmlFor={item.id}
                                   className="custom-checkbox mr-4 font-size-lg">
                              {item.label}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <h3
                  className="card-title font-weight-bold text-dark text-center mb-4">
                  {values.receiptType === 'existing' ? existingReceiptHeader : newReceiptHeader}
                </h3>
                <div className="position-relative">
                  <ReceiptData
                    receiptType={values.receiptType}
                    checkboxValue={values.multipleAgents}
                    values={values}
                    setFieldValue={setFieldValue}
                    findCustomerAction={findCustomerAction}
                    findAgentAction={findAgentAction}
                  />
                  {values.receiptType === 'existing' && (
                    <div className="position-absolute custom-agents-checkbox">
                      <DataItemCheckbox
                        fieldName={'multipleAgents'}
                        label={multipleAgentsLabel}
                        containerClassname={'d-flex justify-content-between mb-4 w-120px'}
                      />
                    </div>
                  )}
                  {values.receiptType === 'new' && (
                    <div className="position-absolute custom-vat-checkbox">
                      <DataItemCheckbox
                        fieldName={'priceIncludeVat'}
                        label={vatIncludedLabel}
                        containerClassname={'d-flex justify-content-between mb-4 w-120px'}
                      />
                    </div>
                  )}
                  <div className="my-3">
                    <UnitGrid
                      values={values}
                      valuesSet={valuesSet}
                      findAgentAction={findAgentAction}
                      setFieldValue={setFieldValue}
                      getInvoicesList={() => {
                        getInvoicesByCustomer(values.customer._id);
                      }}
                      setPopupRowIndex={setPopupRowIndex}
                    />
                  </div>
                  {values.receiptType === 'new'
                    ?
                    <div className="d-flex justify-content-end mr-4">
                      <UnitSummaryDetails
                        vatIncluded={values.priceIncludeVat}
                        lines={values.lines}
                        date={values.dueDate}
                      />
                    </div>
                    : null
                  }
                </div>
                <div className="d-flex justify-content-center mt-8">
                  <Button
                    type={'button'}
                    className="btn btn-secondary btn-sm col-2 mx-3 "
                    onClick={() => {
                      resetForm();
                      setDisabledFields([]);
                      resetDisabledFields();
                      handleCloseModal();
                    }}
                  >
                    {cancelButtonLabel}
                  </Button>
                  {(values.receiptType === 'existing' && values.customer) &&
                    <>
                      <Button
                        type="button"
                        className="btn btn-icon btn-sm col-2 mx-3 custom-send-button"
                        onClick={() => {
                          getInvoicesByCustomer(values.customer._id);
                        }}
                        disabled={values.multipleAgents}
                      >
                        {searchInvoices}
                        <img
                          src={toAbsoluteUrl('/media/svg/Search_white.svg')}
                          alt="receipt"
                          className="h-20px"
                        />
                      </Button>
                      <PopupInvoicesList
                        data={currentState}
                        customerID={values.customer._id}
                        allValues={values}
                        showPopupInvoicesList={showPopupInvoicesList}
                        setShowPopupInvoicesList={setShowPopupInvoicesList}
                        popupRowIndex={popupRowIndex}
                        setFieldValue={setFieldValue}
                        disabledFields={disabledFields}
                        setDisabledFields={setDisabledFields}
                      />
                    </>
                  }
                  <Button
                    className="btn btn-icon btn-sm col-2 mx-3 custom-send-button"
                    type="submit"
                    disabled={!dirty || !isValid}
                    onClick={() => isValid && handleFormSubmit(values, {resetForm})}
                  >
                    {sendButtonLabel}
                  </Button>
                </div>
              </Modal.Body>
            </Modal>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PopupAddReceipt;
